import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaSearch,
  FaChartBar,
  FaGlobe,
  FaBullhorn,
  FaLock,
  FaRocket,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const EcommerceWebsiteSEOServicesInBurDubai = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="E-commerce Website SEO Services in Bur Dubai" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Boost Your Online Visibility</Subheading>}
        heading={
          <Heading>
            E-commerce Website <span tw="text-primary-500">SEO Services</span>{" "}
            in Bur Dubai
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we provide expert e-commerce website SEO services
            in **Bur Dubai**, driving organic traffic, improving rankings, and
            increasing sales for your online store. Let us optimize your site to
            dominate search engines and attract more customers.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1563986768494-4dee2763ff3f?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1533750516457-a7f992034fec?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Boost Your Rankings"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Top SEO Services for E-commerce in Bur Dubai"
        description="We optimize your online store for maximum visibility and growth."
        cards={[
          {
            icon: <FaSearch color="#ff5464" size={40} />,
            title: "Keyword Optimization",
            description:
              "Target the right terms to attract Bur Dubai shoppers.",
          },
          {
            icon: <FaChartBar color="#ff5464" size={40} />,
            title: "Performance Tracking",
            description:
              "Monitor rankings and traffic with detailed analytics.",
          },
          {
            icon: <FaGlobe color="#ff5464" size={40} />,
            title: "Local SEO",
            description: "Dominate search results in Bur Dubai and beyond.",
          },
          {
            icon: <FaBullhorn color="#ff5464" size={40} />,
            title: "Content Strategy",
            description: "Engaging content to boost visibility and sales.",
          },
          {
            icon: <FaLock color="#ff5464" size={40} />,
            title: "Technical SEO",
            description:
              "Fix site issues for better crawlability and security.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Conversion Boost",
            description: "Turn clicks into sales with optimized UX.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our SEO Process for E-commerce Success"
        description={
          <Description>
            We enhance your e-commerce site’s SEO with a proven strategy:
            <ul tw="mt-4 list-disc pl-6">
              <li>Audit: Analyze your site’s current SEO performance.</li>
              <li>Research: Identify high-value keywords for your niche.</li>
              <li>
                Optimization: Enhance on-page elements like meta tags and URLs.
              </li>
              <li>
                Content: Create SEO-friendly product descriptions and blogs.
              </li>
              <li>Link Building: Build authority with quality backlinks.</li>
              <li>
                Monitoring: Track progress and refine for ongoing success.
              </li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1487058792275-0ad4aaf24ca7?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1566241440091-ec10de8db2e1?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1557804506-669a67965ba0?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="SEO Wins for E-commerce in Bur Dubai"
        description="Our SEO services have delivered measurable results for local stores."
        cards={[
          {
            icon: <FaChartBar color="#ff5464" size={40} />,
            title: "Ranking Boost",
            description:
              "Moved a store to page 1 for 10+ keywords in 3 months.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Traffic Surge",
            description: "Increased organic traffic by 250% for a retailer.",
          },
          {
            icon: <FaBullhorn color="#ff5464" size={40} />,
            title: "Sales Growth",
            description: "Doubled online sales with targeted SEO.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Rank Higher?</Subheading>}
        heading="SEO Services for Your E-commerce Store in Bur Dubai"
        description={
          <Description>
            Partner with MilaajBrandset for expert e-commerce website SEO
            services in Bur Dubai. Drive more traffic, attract local customers,
            and grow your sales—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1552581234-26160f608093?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1518186285589-2f7649de83e0?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1502945015378-0e284ca1a5be?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Get Started Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
